import {
Component,
Injector,
Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";

const DEFAULT_CLS = 'app-audio';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-audio',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmAudio]',
  template: `<audio [src]="mp3format " [muted]="muted" [autoplay]="autoplay" [controls]="controls" [loop]="loop" [preload]="audiopreload" role="application" aria-describedby="recorded audio">
    <source type="audio/mp3" [src]="mp3format ">
    {{audiosupportmessage}}
  </audio>`,
  providers: [
    provideAsWidgetRef(AudioComponent)
  ],
  exportAs: 'wmAudio',
  standalone: true,
  imports: [ CommonModule ],
  styles: ['audio { pointer-events: none; }'] // studio widget should not be clickable
})
export class AudioComponent extends StylableComponent {
  static initializeProps = register('wm-audio');
  public mp3format: string;
  public muted: boolean;
  public controls: boolean;
  public loop: boolean;
  public audiopreload: any;
  public audiosupportmessage: any;
  public autoplay: boolean;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

}

